import { render, staticRenderFns } from "./Imofalform6Form.vue?vue&type=template&id=cf2176a6"
import script from "./Imofalform6Form.vue?vue&type=script&lang=js"
export * from "./Imofalform6Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports